import {mapGetters} from 'vuex/dist/vuex.common.js'
import tabContentsMixin from 'js/mixins/journey_tabs.js'

import template from './index.pug'

export default Vue.extend({
  name: 'journeys-tab',
  template: template(),
  mixins: [tabContentsMixin],

  data() {
    return {
      parentItem: '',
      childItem: [],
      currentPage: 1,
      dayLimit: 10,
      dayLimitOptions: [10, 50, 100]
    }
  },
  computed: {
    ...mapGetters('user', [
      'journeysByYearMonth',
      'travels'
    ]),

    journeyDays() {
      return Object.keys(this.journeysByYearMonth).reduce((years, year) => {
        const yearMonths = this.journeysByYearMonth[year]

        return years.concat(Object.keys(yearMonths).reduce((months, month) => {
          const monthDays = yearMonths[month]

          return months.concat(Object.keys(monthDays).map(day => {
            const journeys = this.groupTransferJourneys(monthDays[day])
            const dateKey = this.tripDate(journeys, true)

            return {
              id: `day_${dateKey}`,
              dateKey,
              label: this.tripDate(journeys),
              journeys: _.orderBy(journeys, ['unix'], ['desc'])
            }
          }))
        }, []))
      }, []).sort((a, b) => moment(b.dateKey).valueOf() - moment(a.dateKey).valueOf())
    },

    paginatedJourneyDays() {
      const start = (this.currentPage - 1) * this.dayLimit
      const end = start + this.dayLimit

      return this.journeyDays.slice(start, end)
    },

    totalDays() {
      return this.journeyDays.length
    }
  },

  watch: {
    totalDays() {
      this.currentPage = 1
    }
  },

  methods: {
    isTransferStage(trip) {
      return trip?.is_transfer === true ||
        trip?.is_transfer === 1 ||
        trip?.is_transfer === '1'
    },

    isCappingStage(trip) {
      return trip?.capping_applied === true ||
        (!_.isNil(trip?.capping_limit) && !_.isNil(trip?.capping_sum))
    },

    transferGroupKey(trip) {
      if (!trip?.fecha_inicio_periodo || !trip?.media_code) return null

      return `${trip.media_code}_${trip.fecha_inicio_periodo}`
    },

    groupTransferJourneys(journeys) {
      const grouped = _.groupBy(journeys, trip => (
        this.transferGroupKey(trip) || (_.get(trip, '_id') || trip.id)
      ))

      return Object.keys(grouped).map(key => {
        const stages = _.orderBy(grouped[key], [
          stage => Number(stage.ordinal_grupo || 1),
          stage => stage.unix || 0
        ], ['asc', 'asc'])

        const shouldGroup = stages.length > 1 && stages.some(stage => this.isTransferStage(stage))
        if (!shouldGroup) return stages[0]

        const firstStage = stages[0]
        const lastStage = stages[stages.length - 1]
        const cappingStage = stages.find(stage => this.isCappingStage(stage)) || {}

        return {
          ...firstStage,
          id: `transfer_${key}`,
          amount: _.sumBy(stages, stage => Number(stage.amount || 0)),
          crossed_areas: lastStage.crossed_areas || firstStage.crossed_areas,
          capping_applied: cappingStage.capping_applied || firstStage.capping_applied,
          capping_limit: cappingStage.capping_limit || firstStage.capping_limit,
          capping_sum: cappingStage.capping_sum || firstStage.capping_sum,
          base_amount: cappingStage.base_amount || firstStage.base_amount,
          is_transfer_group: true,
          transfer_stages: stages
        }
      })
    },

    changeDayLimit(limit) {
      this.dayLimit = limit
      this.currentPage = 1
    },

    changeDayPage(page) {
      this.currentPage = page
    }
  }
})
